import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const CalculatorSpecifications = ({ data }) => {
    if (!data || data.length === 0) {
        return null;
    }

    return (
        <section className="bg-[#F0F0F0] py-10">
            <div className="mx-auto max-w-7xl">
                {data[0]?.titletechincalSpecifications && (
                    <h1 className="xs:text-3xl text-center">
                        {data[0].titletechincalSpecifications}
                    </h1>
                )}
                {data[0]?.subtitle && <h2>{data[0].subtitle}</h2>}

                <div className="grid grid-cols-3 xs:grid-cols-1 max-w-7xl mx-auto gap-x-10 xs:my-10 my-20">
                    {Array.isArray(data[1]) &&
                        data[1].map((item, index) => (
                            (item.title || item.image || item.subtitle || item.actionTerciary) && (
                                <div key={index} className="flex flex-col items-center text-center relative">
                                    {item.image && (
                                        <div className="w-20">
                                            <img
                                                src={item.image}
                                                alt={item.title || "Specification Image"}
                                                className="w-full h-full object-contain"
                                            />
                                        </div>
                                    )}
                                    {item.title && <h3 className="pt-4 text-xl font-bold ">{item.title}</h3>}
                                    {item.subtitle && (
                                        <p className="text-lg w-72">{item.subtitle}</p>
                                    )}

                                    {item.actionTerciary && <DropdownLinks item={item} />}
                                </div>
                            )
                        ))}
                </div>
            </div>
        </section>
    );
};

const DropdownLinks = ({ item }) => {
    const [isOpen, setIsOpen] = useState(false);

    const links = [
        { label: "Presentación comercial", url: item.link },
        { label: "One Pager / Flyer", url: item.linkTwo },
        { label: "Guía de Producto", url: item.linkThree },
    ].filter(link => link.url);

    return (
        <div className="text-center relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="text-[#EC0000] font-bold flex items-center mx-auto"
            >
                Conoce más
                {isOpen ? <ChevronUp className="ml-1" size={16} /> : <ChevronDown className="ml-1" size={16} />}
            </button>

            {isOpen && (
                <div className="bg-gray-200 p-3 rounded-md shadow-md absolute bottom-full mb-2 w-56 left-1/2 -translate-x-1/2 z-50">
                    <ul className="text-sm text-black">
                        {links.map((link, index) => (
                            <li key={index} className="mb-1">
                                <a
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="no-underline text-black flex hover:underline items-center"
                                >
                                    <span className="text-[#EC0000] mr-2">•</span>
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default CalculatorSpecifications;
